// Every deployed environment. The SPA is served from the same origin as the
// API, so apiUrl and host are relative - `apiUrl` must not carry a scheme or
// HttpClient stops sending the X-XSRF-TOKEN header.
//
// assetsPrefix is where `ng build` puts the files it copies out of
// resources/images/frontend, and must stay in step with
// App\Support\FrontendAssets::BUILD_DIRECTORY. If a CDN is ever put in front
// of the build output, read the prefix from the shell instead of hard-coding
// it here: index.blade.php can emit FrontendAssets::baseUrl() as a meta tag.
export const environment = {
  production: true,
  apiUrl: '',
  host: '',
  assetsPrefix: '/build',
};
